import { Controller } from '@hotwired/stimulus';

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["updateNewResourceButton"] }] */

export default class extends Controller {
  static targets = ['checkbox']

  updateNewResourceButton () {
    const newResourceButton = document.getElementById('new-resource');
    const checkedCount = Array.from(this.checkboxTargets)
      .filter(checkbox => checkbox.checked).length;

    if (checkedCount > 0) {
      newResourceButton.classList.remove('disabled');
    } else {
      newResourceButton.classList.add('disabled');
    }
  }

  updateEnrollmentsField () {
    const enrollmentsField = document.getElementById('b2b_invoice_enrollments_ids');

    if (enrollmentsField) {
      const checkedEnrollmentsValues = Array.from(this.checkboxTargets)
        .reduce((accumulated, checkbox) => {
          if (checkbox.checked) accumulated.push(checkbox.value);
          return accumulated;
        }, []);

      enrollmentsField.value = checkedEnrollmentsValues.join();
    }
  }
}
